
<template>
  	<LayoutView></LayoutView>
</template>

<!-- // // // //  -->

<script>
import LayoutView from './components/layout.vue'

export default {
  name: 'auth_login',
  components: {
    LayoutView
  },
  metaInfo: {
    title: 'Auth - Login'
  }
}
</script>





// WEBPACK FOOTER //
// src/containers/auth_login/index.vue